import React from 'react'
import assets from '../assets'
import Button from '../Components/Button'
import Datablock from '../Components/Datablock'
import './index.css'
import { motion } from 'framer-motion'

const Section2 = ({handleActivePopUp, variants}) => {
  return (
    <div className='section explore relative' id='explore'>
        <img className='lightSection' src={assets.light.section2} alt="Light" />
        
        <div className="container-lg flex flexCol alignCenter relative">
            <div className="flex flexRow flexWrap selfLeft">
                <motion.h2
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .3 }}
                viewport={{ once: true }}
                className='iconCorner cornerMob'>
                    Empty your mind...<br />
                    Be formless, shapeless.. <br />
                    Be like water
                </motion.h2>
            </div>
            <div className="flex flexRow flexWrap width90 justifySpace alignCenter parentBlock">
                <motion.div
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .5 }}
                viewport={{ once: true }}
                className="iconCorner dataDiv flex flexCol">
                    <Datablock number={'200K'} type={'TPS'} span={'Truly scalable speed'}/>
                    <Datablock number={'<1.98'} type={'SEC'} span={'Transaction finality'}/>
                </motion.div>
                <motion.div
                variants={variants}
                initial={'initial'}
                whileInView={'inView'}
                transition={{ duration: 0.7, delay: .7 }}
                viewport={{ once: true }}
                className="flex flexCol margNegTop">
                    {assets.icons.geo}
                    <div className="absoluteButton">
                        <Button link={'#contact'} text={'Build now'} build handleActivePopUp={handleActivePopUp} popData='build'/>
                    </div>
                </motion.div>
            </div>
        </div>
    </div>
  )
}

export default Section2